const PROVIDER_MAP = [
  { prefix: "sk-ant-",   provider: "Anthropic",  logo: "anthropic", color: "#D4A574", keyType: "anthropic" },
  { prefix: "sk-proj-",  provider: "OpenAI",     logo: "openai",    color: "#10A37F", keyType: "openai" },
  { prefix: "sk-or-",    provider: "OpenRouter", logo: "openrouter",color: "#6366F1", keyType: "openrouter" },
  { prefix: "AIza",      provider: "Google AI",  logo: "google",    color: "#4285F4", keyType: "gemini" },
  { prefix: "DEV-",      provider: "D-Wave",     logo: "dwave",     color: "#0066CC", keyType: "dwave" },
  { prefix: "gsk_",      provider: "Groq",       logo: "groq",      color: "#F55036", keyType: "groq" },
  { prefix: "xai-",      provider: "xAI",        logo: "xai",       color: "#FFFFFF", keyType: "xai" },
  { prefix: "co-",       provider: "Cohere",     logo: "cohere",    color: "#FF7A59", keyType: "cohere" },
  { prefix: "tgp_v1_",   provider: "Together AI",logo: "together",  color: "#6366F1", keyType: "together" },
  { prefix: "pplx-",     provider: "Perplexity", logo: "perplexity",color: "#20808D", keyType: "perplexity" },
  { prefix: "fw_",       provider: "Fireworks AI",logo: "fireworks",color: "#7C3AED", keyType: "fireworks" },
  // OpenAI's legacy `sk-` keys overlap with DeepSeek's. Order matters: try OpenAI first
  // since their keys are 51 chars and start with `sk-` followed by alphanum.
  { prefix: "sk-",       provider: "OpenAI",     logo: "openai",    color: "#10A37F", keyType: "openai" },
];

// Mistral keys are 32-char alphanumeric with no prefix — detect by length+charset.
const MISTRAL_PATTERN = /^[A-Za-z0-9]{32}$/;

export function detectProvider(key) {
  if (!key || key.length < 3) return null;
  const trimmed = key.trim();
  for (const entry of PROVIDER_MAP) {
    if (trimmed.startsWith(entry.prefix)) {
      return { ...entry };
    }
  }
  if (MISTRAL_PATTERN.test(trimmed)) {
    return { prefix: "", provider: "Mistral AI", logo: "mistral", color: "#FF7000", keyType: "mistral" };
  }
  return { prefix: "", provider: "Custom Provider", logo: "custom", color: "#6B7280", keyType: "custom" };
}

export function maskKey(key) {
  if (!key || key.length < 8) return key || "";
  return `${key.slice(0, 6)}...${key.slice(-4)}`;
}

export const PROVIDER_HELP = [
  {
    provider: "OpenAI",
    logo: "openai",
    steps: [
      'Go to your OpenAI dashboard',
      'Click "API Keys" in the left sidebar',
      'Click "+ Create new secret key"',
      'Name it "QNNEAL" and click "Create"',
      'Copy the key and paste it above',
    ],
    url: "https://platform.openai.com/api-keys",
    urlLabel: "Open OpenAI Dashboard",
  },
  {
    provider: "Anthropic",
    logo: "anthropic",
    steps: [
      'Go to the Anthropic console',
      'Click "API Keys" in Settings',
      'Click "Create Key"',
      'Name it "QNNEAL" and click "Create"',
      'Copy the key and paste it above',
    ],
    url: "https://console.anthropic.com/settings/keys",
    urlLabel: "Open Anthropic Console",
  },
  {
    provider: "Google AI",
    logo: "google",
    steps: [
      "Go to Google AI Studio",
      'Click "Get API Key" in the top bar',
      'Click "Create API Key in new project"',
      "Copy the key and paste it above",
    ],
    url: "https://aistudio.google.com/apikey",
    urlLabel: "Open Google AI Studio",
  },
  {
    provider: "Other Providers",
    logo: "custom",
    steps: [
      'Most AI providers have an "API Keys" section in their dashboard or settings.',
      'Look for "API Keys" or "Developer" in the sidebar.',
      'Click "Create new key" or "Generate token".',
      'Copy the key starting with a prefix like sk-',
    ],
    url: null,
    urlLabel: null,
  },
];
